
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import Empty from "@/components/empty.vue";
import TemplateRead from "@/components/template-transfer-pc/crf/template-read.vue";
import TemplateEdit from "@/components/template-transfer-pc/crf/template-edit.vue";
import TemplateTransfer from "@/components/template-transfer-pc/template/template-transfer.vue";
import { GetTemDetail, PatchEditTem } from "@/request/common";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Empty,
    TemplateRead,
    TemplateTransfer,
    TemplateEdit,
  },
})
export default class Name extends Vue {
  private edit: any = false;
  private ifShowAddWenti: any = false;
  private ifShowYulan: any = false;
  private data: any = {};
  private addData: any = {};
  private yulanData: any = {};
  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private update(e: any) {
    this.data["fields"] = e;
    this.forceUpdate();
  }
  private updateData(e: any) {
    this.data["fields"] = e;
    this.ifShowAddWenti = false;
  }
  private openAddTimu() {
    this.ifShowAddWenti = true;
    this.addData = {
      type: "主标题",
      is_required: false,
      hide: false,
    };
  }
  private editWenti(items: any) {
    this.addData = JSON.parse(JSON.stringify(items));
    this.ifShowAddWenti = true;
  }
  private delWenti(index: any) {
    this.data["fields"].splice(index, 1);
  }
  private openYulan() {
    this.$store.commit("updateIfCompose", true);
    this.yulanData = JSON.parse(JSON.stringify(this.data["fields"]));
    this.ifShowYulan = true;
  }
  private updateWholeTem(e: any) {
    this.yulanData = e;
    this.$forceUpdate();
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  /**
   * 导出题目
   */
  private exportTimu() {
    let arr: any = [];
    this.data["fields"].forEach((ele: any) => {
      if (ele.checked) {
        const obj = JSON.parse(JSON.stringify(ele));
        if (obj.control) {
          obj.control = [];
        }
        delete obj.checked;
        arr.push(obj);
      }
    });
    if (arr.length == 0) {
      this.$message.warning("请选择需要导出的题目");
      return;
    }
    const data: any = {
      模板: arr,
    };
    const jsonString = JSON.stringify(data);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "data.json";
    link.click();
  }
  /**
   * @description 导入题目
   */
  private uploadTimuFile(d: any) {
    const file = d.file;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const content = JSON.parse(e.target.result)["模板"];
        // 需要重新生成题目id
        if (content && content.length > 0) {
          content.forEach((ele: any, index: any) => {
            ele.id = new Date().getTime() + index;
          });
          this.data["fields"] = this.data["fields"].concat(content);
        }
      } catch (error) {
        this.$message.error("文件内容不是有效的 JSON 格式!");
      }
    };
    reader.readAsText(file);
    // 不需要实际发送请求，因此返回 false
    return false;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemDetail(this, this.data.id, loading).then((res: any) => {
      this.data = res.data;
    });
  }
  /**
   * @description 保存
   */
  private save() {
    // 处理this.data["fields"],把里面的is_required设置为false
    //this.data["fields"].forEach((ele: any) => {
    //  ele.is_required = false;
    //});
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      fields: this.data["fields"],
    };
    PatchEditTem(this, this.data.id, params, loading).then((res: any) => {
      this.$message.success("保存成功");
      this.edit = false;
      this.getData();
    });
  }
  private mounted() {
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getData();
    }
  }
}
